import { render } from "./AnnotationFeaturesWidget.vue?vue&type=template&id=a05ef1b0&scoped=true"
import script from "./AnnotationFeaturesWidget.vue?vue&type=script&lang=js"
export * from "./AnnotationFeaturesWidget.vue?vue&type=script&lang=js"

import "./AnnotationFeaturesWidget.vue?vue&type=style&index=0&id=a05ef1b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05ef1b0"]])

export default __exports__